import React, { useEffect, useState } from "react";
import {
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Text,
  Image,
  IconButton,
  Flex,
  Heading,
  Button,
  Spinner,
  VStack,
  SimpleGrid,
  GridItem,
  Stack,
} from "@chakra-ui/react";
import { DeleteIcon } from "@chakra-ui/icons";
import axios from "axios";
import EditItemDrawer from "./edit-drawer";
const backendUrl = process.env.REACT_APP_BACKEND_URL;

const CarsList = ({ handleUpdateItem, handleDelete }) => {
  const [cars, setCars] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCars(currentPage);
  }, [currentPage]);

  const fetchCars = async (page) => {
    setLoading(true);
    try {
      const response = await axios.get(
          `${backendUrl}/api/cars?page=${page}`
      );
      setCars(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setTotalPages(response.data.data.last_page);
    } catch (error) {
      console.error("Error fetching cars:", error);
    }
    setLoading(false);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
      <Box zIndex="1000000">
        <Flex justify="space-between" mb={4}>
          <Heading size="lg">Cars</Heading>
          <Button onClick={() => fetchCars(currentPage)}>Refresh</Button>
        </Flex>
        {loading ? (
            <Spinner size="xl" />
        ) : (
            <Box>
              <SimpleGrid columns={6} p="8px 16px" textAlign="left">
                <GridItem>
                  <Text fontWeight="bold">Brand</Text>
                </GridItem>
                <GridItem>
                  <Text fontWeight="bold">Model</Text>
                </GridItem>
                <GridItem>
                  <Text fontWeight="bold">Gearbox</Text>
                </GridItem>
                <GridItem>
                  <Text fontWeight="bold">Fuel Type</Text>
                </GridItem>
                <GridItem>
                  <Text fontWeight="bold">Price</Text>
                </GridItem>
                <GridItem>
                  <Text fontWeight="bold">Operations</Text>
                </GridItem>
              </SimpleGrid>
              <Accordion allowToggle>
                {cars.map((car) => (
                    <AccordionItem key={car.id}>
                      <AccordionButton>
                        <Box flex="1" textAlign="left">
                          <SimpleGrid columns={6} spacing={4} textAlign="left">
                            <GridItem>{car.brand}</GridItem>
                            <GridItem>{car.model}</GridItem>
                            <GridItem>{car.gearbox}</GridItem>
                            <GridItem>{car.fuel_type}</GridItem>
                            <GridItem>${car.price}</GridItem>
                            <GridItem>
                              <Flex>
                                <EditItemDrawer
                                    dataType="cars"
                                    item={car}
                                    onUpdate={(updatedItem) =>
                                        handleUpdateItem(car.id, updatedItem)
                                    }
                                />
                                <IconButton
                                    onClick={() => handleDelete(car.id)}
                                    bg=""
                                    _hover={{ bg: "red.500", color: "white" }}
                                    ml={1}
                                    aria-label="Delete"
                                    icon={<DeleteIcon />}
                                />
                              </Flex>
                            </GridItem>
                          </SimpleGrid>
                        </Box>
                        <AccordionIcon />
                      </AccordionButton>
                      <AccordionPanel
                          boxShadow="md"
                          p="5"
                          rounded="md"
                          bg="gray.50">
                        <Stack
                            direction={{ base: "column", lg: "row" }}
                        >
                          <Box
                              w={{ base: "100%", lg: "50%" }}
                              p={"0 5%"}
                              h={"full"}
                          >
                            <VStack alignItems={"flex-start"} spacing={3}>
                              <Heading size="md">Car Details</Heading>
                              <Text>
                                <b>Brand:</b> {car.brand}
                              </Text>
                              <Text>
                                <b>Model:</b> {car.model}
                              </Text>
                              <Text>
                                <b>Fuel Type:</b> {car.fuel_type}
                              </Text>
                              <Text>
                                <b>Price:</b> {car.price}
                              </Text>
                              <Text>
                                <b>Gearbox:</b> {car.gearbox}
                              </Text>
                            </VStack>
                          </Box>
                          <Stack
                              direction={{ base: "column", lg: "row" }}
                              mt={4}
                              p={"0 5%"}
                              spacing={4}
                              width={"100%"}
                              height={{ base: "auto", lg: "100%" }}
                          >
                            <Image
                                src={car.photo1}
                                objectFit="cover"
                                width={{ base: "100%", lg: "50%" }}
                                height={"100%"}
                                borderRadius="md"
                            />
                            <Image
                                src={car.photo2}
                                objectFit="cover"
                                width={{ base: "100%", lg: "50%" }}
                                height={"100%"}
                                borderRadius="md"
                            />
                          </Stack>
                        </Stack>
                      </AccordionPanel>
                    </AccordionItem>
                ))}
              </Accordion>
            </Box>
        )}
        <Flex mt={4} justify="center">
          {Array.from({ length: totalPages }, (_, i) => (
              <Button
                  key={i + 1}
                  onClick={() => handlePageChange(i + 1)}
                  disabled={currentPage === i + 1}
                  mx={1}
              >
                {i + 1}
              </Button>
          ))}
        </Flex>
      </Box>
  );
};

export default CarsList;
